import React from "react";
import {Navigate, Outlet, RouteProps} from "react-router-dom";
import {useSelector} from "react-redux";
import {isLoggedIn} from "modules/selectors";
import {useLocation} from "react-router";

/**
 * Set redirect uri, to return back after login.
 */
const getUri = (redirectUri: string) =>
	redirectUri ? `/login?redirectUri=${redirectUri}` : `/login`;

export const PrivateRoute: React.FC<RouteProps> = () => {
	const location = useLocation();

	if (useSelector(isLoggedIn)) {
		return <Outlet />;
	}

	return <Navigate to={getUri(location.pathname)} state={{from: location}} replace />;
};
